import { User } from 'dragonmouse-shared/interfaces';
import { resolveOptimisticallyUpdatedUser, updateUser } from '../../redux/db/actions';
import store from '../../redux/store';
import { VITE_FORGE_URL } from '../../constants';
import { UserRow } from '../types';
import { parsePostgresDate } from '../util';
import { Stream } from './Stream';
import { ChangeMessage, isChangeMessage, Message, Row } from '@electric-sql/client';

export class UserStream extends Stream<UserRow> {
	constructor(userId: string) {
		const url = VITE_FORGE_URL + '/electric/user';
		const params = { userId };

		const onError = (error: Error) => {
			console.error('User stream error:', error);
			store.dispatch(updateUser(null));
		};

		super(url, params, onError, 'user');
	}

	onShapeData(rows: UserRow[]) {
		if (rows.length > 0) {
			const userRow = rows[0];
			const user: User = {
				id: userRow.id,
				displayName: userRow.display_name,
				metadata: userRow.metadata,
				createdAt: parsePostgresDate(userRow.created_at),
				writeId: userRow.write_id,
			};
			store.dispatch(updateUser(user));
		} else {
			store.dispatch(updateUser(null));
		}
	}

	onStreamMessages(messages: Array<unknown>) {
		const writeIds = messages
			.filter((msg): msg is ChangeMessage<UserRow> => isChangeMessage(msg as Message<Row<never>>))
			.map((message): string => {
				return message.value.write_id || `delete:${message.value.id}`;
			});
		store.dispatch(resolveOptimisticallyUpdatedUser(writeIds));
	}
}
